import React from 'react'
import StoreTabContent from '../components/StoreTabContent'
import ProfileHeaderSlider from '../components/Header-Slider/ProfileHeaderSlider'
import HeaderSlider from '../components/Header-Slider/HeaderSlider'
import HeaderMainNavigation from '../layout/HeaderMainNavigation'
import Footer from '../components/Footer/Footer'

export default function Shop() {




  
  return (
    <React.Fragment>
    <ProfileHeaderSlider />
        <HeaderSlider />
        <HeaderMainNavigation />
        <section className="shop-page section-padding">
            <StoreTabContent />
        </section>
        <Footer/>
    </React.Fragment>
  )
}
